import { CertificationStatus } from 'api';
import { createEnumOptions } from 'const/createEnumOptions';
import { getCertificationStatusName } from './certificationStatusHelpers';

export const CERTIFICATION_STATUS_OPTIONS = createEnumOptions(
  CertificationStatus,
  getCertificationStatusName
);
